/* eslint-disable */
// src/pages/Pravachan.tsx — Light Theme, with upload progress %

import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../contexts/AuthContext';
import {
  ref as storageRef,
  uploadBytesResumable,   // ← replaces uploadBytes
  getDownloadURL,
  deleteObject,
} from 'firebase/storage';
import { ref as databaseRef, set, get } from 'firebase/database';
import { storage, dbRealtime } from '../environments/firebase';
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

// ─── Icons ────────────────────────────────────────────────────
const Ic = {
  Back:     () => <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"/></svg>,
  Camera:   () => <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z"/><circle cx="12" cy="13" r="4"/></svg>,
  Mic:      () => <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M12 1a3 3 0 00-3 3v8a3 3 0 006 0V4a3 3 0 00-3-3z"/><path d="M19 10v2a7 7 0 01-14 0v-2"/><line x1="12" y1="19" x2="12" y2="23"/><line x1="8" y1="23" x2="16" y2="23"/></svg>,
  Text:     () => <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><polyline points="4 7 4 4 20 4 20 7"/><line x1="9" y1="20" x2="15" y2="20"/><line x1="12" y1="4" x2="12" y2="20"/></svg>,
  Play:     () => <svg width="18" height="18" fill="currentColor" viewBox="0 0 24 24"><polygon points="5 3 19 12 5 21 5 3"/></svg>,
  Pause:    () => <svg width="18" height="18" fill="currentColor" viewBox="0 0 24 24"><rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/></svg>,
  Globe:    () => <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"/></svg>,
  Lock:     () => <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg>,
  Close:    () => <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>,
  Upload:   () => <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>,
  Check:    () => <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>,
  Add:      () => <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="16"/><line x1="8" y1="12" x2="16" y2="12"/></svg>,
  Bold:     () => <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M6 4h8a4 4 0 014 4 4 4 0 01-4 4H6z"/><path d="M6 12h9a4 4 0 014 4 4 4 0 01-4 4H6z"/></svg>,
  Italic:   () => <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><line x1="19" y1="4" x2="10" y2="4"/><line x1="14" y1="20" x2="5" y2="20"/><line x1="15" y1="4" x2="9" y2="20"/></svg>,
  Pdf:      () => <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><path d="M9 15v-1a1 1 0 012 0v1a1 1 0 01-2 0z"/><path d="M9 13h2"/><path d="M13 15v-3h1.5a1.5 1.5 0 010 3H13z"/><path d="M7 15v-3"/><path d="M7 13.5h1"/></svg>,
  ExternalLink: () => <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>,
};

// ─── Helpers ──────────────────────────────────────────────────
const fmt = (s: number) => `${Math.floor(s / 60).toString().padStart(2, '0')}:${(s % 60).toString().padStart(2, '0')}`;

type Mode        = 'pick' | 'compose';
type ContentType = 'text' | 'image' | 'audio';

interface ImageFile { url: string; name: string; preview: string; }
interface AudioFile { url: string; name: string; }
interface PdfFile  { url: string; name: string; label: string; }

// ─── Upload progress state ────────────────────────────────────
interface UploadTask {
  name:     string;
  label:    string;   // friendly filename
  progress: number;   // 0–100
  done:     boolean;
  error:    boolean;
}

// ─── Light Theme Token ────────────────────────────────────────
const T = {
  bg:       '#F7F5F0',
  surface:  '#FFFFFF',
  surface2: '#F0EDE8',
  border:   '#E5E0D8',
  text:     '#1A1714',
  muted:    '#8A8178',
  accent:   '#C2610A',
  accentBg: '#FEF3E8',
  green:    '#15803D',
  red:      '#DC2626',
  shadow:   '0 1px 3px rgba(0,0,0,0.07), 0 1px 2px rgba(0,0,0,0.04)',
  shadowMd: '0 4px 12px rgba(0,0,0,0.08)',
};

// ─── Upload Progress Bar ──────────────────────────────────────
function UploadProgressToast({ tasks }: { tasks: UploadTask[] }) {
  const active = tasks.filter(t => !t.done && !t.error);
  const errors = tasks.filter(t => t.error);
  if (!tasks.length) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 40 }}
      style={{
        position: 'fixed', bottom: 24, left: '50%', transform: 'translateX(-50%)',
        zIndex: 9000, width: 'min(340px, 90vw)',
        background: T.text, borderRadius: 16,
        padding: '14px 16px', boxShadow: '0 8px 24px rgba(0,0,0,0.25)',
        display: 'flex', flexDirection: 'column', gap: 10,
      }}
    >
      {tasks.map(task => (
        <div key={task.name}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 5 }}>
            <span style={{ color: '#fff', fontSize: 12, fontWeight: 600, maxWidth: 220, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {task.error ? '⚠️ ' : task.done ? '✅ ' : '⏫ '}{task.label}
            </span>
            <span style={{ color: task.error ? '#FCA5A5' : task.done ? '#6EE7B7' : '#FCD34D', fontSize: 12, fontWeight: 700, flexShrink: 0 }}>
              {task.error ? 'Failed' : task.done ? 'Done' : `${task.progress}%`}
            </span>
          </div>
          {/* Progress track */}
          <div style={{ height: 4, background: 'rgba(255,255,255,0.15)', borderRadius: 2, overflow: 'hidden' }}>
            <motion.div
              animate={{ width: `${task.error ? 100 : task.progress}%` }}
              transition={{ ease: 'linear', duration: 0.3 }}
              style={{
                height: '100%', borderRadius: 2,
                background: task.error ? T.red : task.done ? T.green : T.accent,
              }}
            />
          </div>
        </div>
      ))}

      {active.length > 0 && (
        <p style={{ margin: 0, color: 'rgba(255,255,255,0.5)', fontSize: 11, textAlign: 'center' }}>
          Please keep this page open while uploading…
        </p>
      )}
      {errors.length > 0 && (
        <p style={{ margin: 0, color: '#FCA5A5', fontSize: 11, textAlign: 'center' }}>
          {errors.length} file{errors.length > 1 ? 's' : ''} failed. Check connection & try again.
        </p>
      )}
    </motion.div>
  );
}

// ─── Audio Player ─────────────────────────────────────────────
function AudioPlayer({ src }: { src: string }) {
  const [playing, setPlaying] = useState(false);
  const [time, setTime]       = useState(0);
  const [dur, setDur]         = useState(0);
  const audioRef              = useRef<HTMLAudioElement>(null);

  const toggle = () => {
    if (!audioRef.current) return;
    if (playing) { audioRef.current.pause(); setPlaying(false); }
    else { audioRef.current.play(); setPlaying(true); }
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12, background: T.surface2, borderRadius: 12, padding: '12px 16px', border: `1px solid ${T.border}` }}>
      <button onClick={toggle} style={{ width: 38, height: 38, borderRadius: '50%', background: T.accent, display: 'flex', alignItems: 'center', justifyContent: 'center', border: 'none', cursor: 'pointer', flexShrink: 0, color: '#fff', boxShadow: '0 2px 6px rgba(194,97,10,0.3)' }}>
        {playing ? <Ic.Pause /> : <Ic.Play />}
      </button>
      <div style={{ flex: 1 }}>
        <div style={{ height: 3, background: T.border, borderRadius: 2, position: 'relative', cursor: 'pointer' }}
          onClick={e => { if (!audioRef.current || !dur) return; const r = e.currentTarget.getBoundingClientRect(); audioRef.current.currentTime = ((e.clientX - r.left) / r.width) * dur; }}>
          <div style={{ height: '100%', background: T.accent, borderRadius: 2, width: `${dur ? (time / dur) * 100 : 0}%` }} />
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 4 }}>
          <span style={{ fontSize: 10, color: T.muted }}>{fmt(time)}</span>
          <span style={{ fontSize: 10, color: T.muted }}>{fmt(dur)}</span>
        </div>
      </div>
      <audio ref={audioRef} src={src}
        onTimeUpdate={() => setTime(audioRef.current?.currentTime || 0)}
        onLoadedMetadata={() => setDur(audioRef.current?.duration || 0)}
        onEnded={() => setPlaying(false)} />
    </div>
  );
}

// ─── Image Carousel ───────────────────────────────────────────
function ImageCarousel({ images, onRemove }: { images: ImageFile[]; onRemove: (name: string) => void }) {
  const [idx, setIdx] = useState(0);
  if (!images.length) return null;
  return (
    <div style={{ position: 'relative', width: '100%', aspectRatio: '1', background: '#000', overflow: 'hidden', borderRadius: 16 }}>
      <AnimatePresence mode="wait">
        <motion.img key={idx} src={images[idx].preview} initial={{ opacity: 0, x: 40 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -40 }} transition={{ duration: 0.2 }} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
      </AnimatePresence>
      <button onClick={() => { onRemove(images[idx].name); setIdx(Math.max(0, idx - 1)); }}
        style={{ position: 'absolute', top: 10, right: 10, background: 'rgba(0,0,0,0.55)', border: 'none', borderRadius: '50%', width: 30, height: 30, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', cursor: 'pointer', backdropFilter: 'blur(4px)' }}><Ic.Close /></button>
      {images.length > 1 && (
        <div style={{ position: 'absolute', bottom: 10, left: '50%', transform: 'translateX(-50%)', display: 'flex', gap: 4 }}>
          {images.map((_, i) => <button key={i} onClick={() => setIdx(i)} style={{ width: i === idx ? 18 : 6, height: 6, borderRadius: 3, background: i === idx ? '#fff' : 'rgba(255,255,255,0.5)', border: 'none', cursor: 'pointer', transition: 'all 0.2s', padding: 0 }} />)}
        </div>
      )}
      {images.length > 1 && idx > 0 && <button onClick={() => setIdx(idx - 1)} style={{ position: 'absolute', left: 8, top: '50%', transform: 'translateY(-50%)', background: 'rgba(0,0,0,0.5)', border: 'none', borderRadius: '50%', width: 32, height: 32, color: '#fff', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Ic.Back /></button>}
      {images.length > 1 && idx < images.length - 1 && <button onClick={() => setIdx(idx + 1)} style={{ position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)', background: 'rgba(0,0,0,0.5)', border: 'none', borderRadius: '50%', width: 32, height: 32, color: '#fff', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', rotate: '180deg' }}><Ic.Back /></button>}
    </div>
  );
}

// ─── Recording Visualiser ─────────────────────────────────────
function RecordingVisualiser({ active }: { active: boolean }) {
  return (
    <div style={{ display: 'flex', alignItems: 'flex-end', gap: 3, height: 32, justifyContent: 'center' }}>
      {[...Array(12)].map((_, i) => (
        <motion.div key={i}
          animate={active ? { height: [8, 24, 8], transition: { repeat: Infinity, duration: 0.6, delay: i * 0.06, ease: 'easeInOut' } } : { height: 4 }}
          style={{ width: 3, background: active ? T.red : T.border, borderRadius: 2 }} />
      ))}
    </div>
  );
}

// ─── Utility: resumable upload with progress ──────────────────
function uploadWithProgress(
  path: string,
  blob: Blob,
  onProgress: (pct: number) => void,
): Promise<string> {
  return new Promise((resolve, reject) => {
    const ref  = storageRef(storage, path);
    const task = uploadBytesResumable(ref, blob);

    task.on(
      'state_changed',
      snap => {
        const pct = Math.round((snap.bytesTransferred / snap.totalBytes) * 100);
        onProgress(pct);
      },
      err => reject(err),
      async () => {
        try {
          const url = await getDownloadURL(task.snapshot.ref);
          resolve(url);
        } catch (e) {
          reject(e);
        }
      },
    );
  });
}

// ─── PDF List ─────────────────────────────────────────────────
function PdfList({ pdfs, onRemove }: { pdfs: PdfFile[]; onRemove: (name: string) => void }) {
  if (!pdfs.length) return null;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginTop: 4 }}>
      {pdfs.map(pdf => (
        <div key={pdf.name} style={{ display: 'flex', alignItems: 'center', gap: 12, background: '#FFF7ED', border: `1px solid #FED7AA`, borderRadius: 12, padding: '11px 14px' }}>
          {/* Red PDF badge */}
          <div style={{ width: 36, height: 36, borderRadius: 8, background: '#DC2626', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            <span style={{ color: '#fff', fontSize: 9, fontWeight: 800, letterSpacing: '0.03em' }}>PDF</span>
          </div>
          <span style={{ flex: 1, fontSize: 13, fontWeight: 600, color: T.text, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {pdf.label}
          </span>
          <a href={pdf.url} target="_blank" rel="noreferrer"
            style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: 12, color: T.accent, fontWeight: 600, textDecoration: 'none', flexShrink: 0 }}>
            Open <Ic.ExternalLink />
          </a>
          <button onClick={() => onRemove(pdf.name)}
            style={{ background: 'none', border: 'none', color: T.muted, cursor: 'pointer', padding: 2, display: 'flex', alignItems: 'center', flexShrink: 0 }}>
            <Ic.Close />
          </button>
        </div>
      ))}
    </div>
  );
}


export default function Pravachan() {
  const { currentUser } = useAuth();
  const navigate        = useNavigate();

  const [vakta, setVakta]       = useState('');
  const [topic, setTopic]       = useState('');
  const [caption, setCaption]   = useState('');
  const [dateTime, setDateTime] = useState('');
  const [postPublicly, setPostPublicly] = useState(true);

  const [contentType, setContentType] = useState<ContentType>('text');
  const [mode, setMode]               = useState<Mode>('pick');
  const [images, setImages]           = useState<ImageFile[]>([]);
  const [audioFiles, setAudioFiles]   = useState<AudioFile[]>([]);
  const [pdfFiles, setPdfFiles]       = useState<PdfFile[]>([]);

  // ── Recording state ──
  const [recording, setRecording]         = useState(false);
  const [recTime, setRecTime]             = useState(0);
  const [localAudioURL, setLocalAudioURL] = useState<string | null>(null);
  const mediaRecRef = useRef<MediaRecorder | null>(null);
  const chunksRef   = useRef<Blob[]>([]);
  const recTimerRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const wakeLockRef = useRef<any>(null);

  // ── Upload progress ──
  const [uploadTasks, setUploadTasks] = useState<UploadTask[]>([]);
  const anyUploading = uploadTasks.some(t => !t.done && !t.error);

  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess]       = useState(false);

  const editorRef   = useRef<HTMLDivElement>(null);
  const imgInputRef = useRef<HTMLInputElement>(null);
  const audInputRef = useRef<HTMLInputElement>(null);
  const pdfInputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    setDateTime(new Date().toISOString().slice(0, 16));
    return () => {
      if (recTimerRef.current) clearInterval(recTimerRef.current);
      wakeLockRef.current?.release();
    };
  }, []);

  // ── helpers to manage per-file task entries ──
  const addTask = (name: string, label: string) =>
    setUploadTasks(prev => [...prev, { name, label, progress: 0, done: false, error: false }]);

  const updateTask = (name: string, progress: number) =>
    setUploadTasks(prev => prev.map(t => t.name === name ? { ...t, progress } : t));

  const finishTask = (name: string, error = false) =>
    setUploadTasks(prev => prev.map(t => t.name === name ? { ...t, progress: 100, done: !error, error } : t));

  // Auto-dismiss completed toasts after 3 s
  useEffect(() => {
    const allDone = uploadTasks.length > 0 && uploadTasks.every(t => t.done || t.error);
    if (!allDone) return;
    const id = setTimeout(() => setUploadTasks([]), 3000);
    return () => clearTimeout(id);
  }, [uploadTasks]);

  // ── Image upload ──
  const handleImageSelect = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;

    for (const file of files) {
      const preview = URL.createObjectURL(file);
      const name    = `img_${Date.now()}_${file.name}`;
      const label   = file.name.length > 28 ? file.name.slice(0, 25) + '…' : file.name;

      addTask(name, label);
      try {
        const url = await uploadWithProgress(
          `Pravachan/${name}`,
          file,
          pct => updateTask(name, pct),
        );
        finishTask(name);
        setImages(prev => [...prev, { url, name, preview }]);
      } catch {
        finishTask(name, true);
      }
    }
    // reset input so same file can be re-uploaded after an error
    e.target.value = '';
  };

  const removeImage = async (name: string) => {
    try { await deleteObject(storageRef(storage, `Pravachan/${name}`)); } catch {}
    setImages(prev => prev.filter(i => i.name !== name));
  };

  // ── Audio file upload ──
  const handleAudioSelect = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;

    for (const file of files) {
      const name  = `aud_${Date.now()}_${file.name}`;
      const label = file.name.length > 28 ? file.name.slice(0, 25) + '…' : file.name;

      addTask(name, label);
      try {
        const url = await uploadWithProgress(
          `Pravachan/${name}`,
          file,
          pct => updateTask(name, pct),
        );
        finishTask(name);
        setAudioFiles(prev => [...prev, { url, name }]);
      } catch {
        finishTask(name, true);
      }
    }
    e.target.value = '';
  };

  // ── PDF file upload ──
  const handlePdfSelect = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;

    for (const file of files) {
      if (file.type !== 'application/pdf' && !file.name.toLowerCase().endsWith('.pdf')) {
        alert(`"${file.name}" is not a PDF file.`);
        continue;
      }
      const name  = `pdf_${Date.now()}_${file.name}`;
      const label = file.name.length > 36 ? file.name.slice(0, 33) + '…' : file.name;

      addTask(name, label);
      try {
        const url = await uploadWithProgress(
          `Pravachan/${name}`,
          file,
          pct => updateTask(name, pct),
        );
        finishTask(name);
        setPdfFiles(prev => [...prev, { url, name, label }]);
      } catch {
        finishTask(name, true);
      }
    }
    e.target.value = '';
  };

  const removePdf = async (name: string) => {
    try { await deleteObject(storageRef(storage, `Pravachan/${name}`)); } catch {}
    setPdfFiles(prev => prev.filter(p => p.name !== name));
  };


  const startRecording = async () => {
    try {
      if ('wakeLock' in navigator) wakeLockRef.current = await (navigator as any).wakeLock.request('screen');
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mime   = ['audio/webm;codecs=opus', 'audio/mp4', 'audio/ogg'].find(t => MediaRecorder.isTypeSupported(t)) || '';
      mediaRecRef.current = new MediaRecorder(stream, mime ? { mimeType: mime } : {});
      chunksRef.current   = [];
      mediaRecRef.current.ondataavailable = e => { if (e.data.size > 0) chunksRef.current.push(e.data); };
      mediaRecRef.current.onstop = () => {
        const blob = new Blob(chunksRef.current, { type: mediaRecRef.current?.mimeType || 'audio/wav' });
        setLocalAudioURL(URL.createObjectURL(blob));
        stream.getTracks().forEach(t => t.stop());
        wakeLockRef.current?.release();
      };
      mediaRecRef.current.start(1000);
      setRecording(true);
      setRecTime(0);
      recTimerRef.current = setInterval(() => setRecTime(p => p + 1), 1000);
    } catch { alert('Microphone access denied.'); }
  };

  const stopRecording = () => {
    mediaRecRef.current?.stop();
    setRecording(false);
    if (recTimerRef.current) clearInterval(recTimerRef.current);
  };

  const saveLocalRecording = async () => {
    if (!localAudioURL) return;
    const res  = await fetch(localAudioURL);
    const blob = await res.blob();
    const ext  = (mediaRecRef.current?.mimeType || '').includes('webm') ? 'webm'
               : (mediaRecRef.current?.mimeType || '').includes('mp4')  ? 'm4a' : 'wav';
    const name  = `recording_${Date.now()}.${ext}`;
    const label = `Recording ${new Date().toLocaleTimeString()}`;

    addTask(name, label);
    try {
      const url = await uploadWithProgress(
        `Pravachan/${name}`,
        blob,
        pct => updateTask(name, pct),
      );
      finishTask(name);
      setAudioFiles(prev => [...prev, { url, name }]);
      setLocalAudioURL(null);
      setRecTime(0);
    } catch {
      finishTask(name, true);
    }
  };

  // ── User display info ──
  const getDisplayInfo = async (): Promise<{ displayName: string; avatarUrl?: string }> => {
    if (!currentUser) return { displayName: 'Anonymous' };
    try {
      const snap = await get(databaseRef(dbRealtime, `users/${currentUser.uid}/profile`));
      if (snap.exists()) {
        const p = snap.val();
        return {
          displayName: `${p.firstName || ''} ${p.lastName || ''}`.trim() || currentUser.email?.split('@')[0] || 'Devotee',
          avatarUrl: p.avatarUrl,
        };
      }
    } catch {}
    return { displayName: currentUser.email?.split('@')[0] || 'Devotee' };
  };

  // ── Submit ──
  const handleSubmit = async () => {
    if (!currentUser || !topic.trim() || !vakta.trim() || anyUploading) return;
    setSubmitting(true);
    try {
      const ts    = new Date(dateTime).getTime();
      const dbRef = databaseRef(dbRealtime, `users/${currentUser.uid}/kathaAmrut/${ts}`);
      const notes = contentType === 'text' ? (editorRef.current?.innerHTML || '') : '';

      const data: any = {
        vakta:      vakta.trim(),
        topic:      topic.trim(),
        caption:    caption.trim(),
        dateTime,
        createdAt:  { '.sv': 'timestamp' },
        isPublic:   postPublicly,
        notes,
        images:     images.map(i => i.url),
        audioFiles: audioFiles.map(a => a.url),
        pdfFiles:   pdfFiles.map(p => ({ url: p.url, label: p.label })),
      };

      await set(dbRef, data);

      if (postPublicly) {
        const { displayName, avatarUrl } = await getDisplayInfo();
        const feedId  = `feed_${currentUser.uid}_${ts}`;
        const feedRef = databaseRef(dbRealtime, `publicFeed/${feedId}`);
        await set(feedRef, {
          type:          'pravachan',
          userId:        currentUser.uid,
          displayName,
          avatarInitial: displayName.charAt(0).toUpperCase(),
          avatarUrl:     avatarUrl || null,
          topic:         data.topic,
          vakta:         data.vakta,
          caption:       data.caption,
          dateTime:      data.dateTime,
          notes,
          images:        data.images,
          audioFiles:    data.audioFiles,
          pdfFiles:      data.pdfFiles,
          createdAt:     ts,
          likes: {}, comments: {}, saves: {},
        });
      }

      setVakta(''); setTopic(''); setCaption('');
      setImages([]); setAudioFiles([]); setPdfFiles([]);
      if (editorRef.current) editorRef.current.innerHTML = '';
      setPostPublicly(true);
      setMode('pick');
      setSuccess(true);
      setTimeout(() => { setSuccess(false); navigate('/pravachan-report'); }, 2000);
    } catch (err) {
      console.error(err);
      alert('Failed to save. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  const canPost = topic.trim() && vakta.trim() && !submitting && !anyUploading;

  const inputStyle: React.CSSProperties = {
    width: '100%', boxSizing: 'border-box' as const,
    background: 'transparent', border: 'none', outline: 'none',
    color: T.text, fontFamily: 'inherit', fontSize: 15,
  };

  return (
    <div style={{ minHeight: '100vh', background: T.bg, fontFamily: "-apple-system,'Helvetica Neue',sans-serif", color: T.text, maxWidth: 480, margin: '0 auto' }}>

      {/* ── Upload progress toasts ── */}
      <AnimatePresence>
        {uploadTasks.length > 0 && <UploadProgressToast tasks={uploadTasks} />}
      </AnimatePresence>

      {/* ── Success overlay ── */}
      <AnimatePresence>
        {success && (
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            style={{ position: 'fixed', inset: 0, zIndex: 9999, background: 'rgba(247,245,240,0.96)', backdropFilter: 'blur(8px)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 16 }}>
            <motion.div initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ type: 'spring', stiffness: 300, damping: 20 }}
              style={{ width: 72, height: 72, borderRadius: '50%', background: T.green, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff' }}><Ic.Check /></motion.div>
            <p style={{ fontSize: 18, fontWeight: 700, color: T.text }}>{postPublicly ? 'Posted to community!' : 'Saved privately!'}</p>
          </motion.div>
        )}
      </AnimatePresence>

      {/* ── STEP 1: Pick content type ── */}
      <AnimatePresence mode="wait">
        {mode === 'pick' && (
          <motion.div key="pick" initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -16 }} style={{ padding: '24px 20px' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 32 }}>
              <button onClick={() => navigate(-1)} style={{ background: 'none', border: 'none', color: T.muted, cursor: 'pointer', padding: 4 }}><Ic.Close /></button>
              <h1 style={{ fontFamily: 'Georgia,serif', fontSize: 18, fontWeight: 700, margin: 0, color: T.text }}>New Pravachan</h1>
              <div style={{ width: 28 }} />
            </div>

            <div style={{ background: T.accentBg, border: `1px solid rgba(194,97,10,0.25)`, borderRadius: 12, padding: '10px 14px', marginBottom: 20, display: 'flex', alignItems: 'center', gap: 10 }}>
              <Ic.Globe />
              <p style={{ margin: 0, fontSize: 13, color: T.accent, fontWeight: 600 }}>Posts go to the community feed by default. You can keep it private in the next step.</p>
            </div>

            <p style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: T.muted, marginBottom: 14 }}>What are you sharing?</p>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {([
                { type: 'text',  label: 'Pravachan Notes',  sub: 'Write thoughts, insights & teachings', icon: <Ic.Text />,   grad: 'linear-gradient(135deg,#1D9E75,#0F6E56)' },
                { type: 'image', label: 'Photo + Caption',  sub: 'Share images with a pravachan caption', icon: <Ic.Camera />, grad: 'linear-gradient(135deg,#D97706,#92400E)' },
                { type: 'audio', label: 'Audio Recording',  sub: 'Record or upload a pravachan',          icon: <Ic.Mic />,    grad: 'linear-gradient(135deg,#7C3AED,#4C1D95)' },
              ] as const).map(opt => (
                <motion.button key={opt.type} whileTap={{ scale: 0.98 }}
                  onClick={() => { setContentType(opt.type); setMode('compose'); }}
                  style={{ display: 'flex', alignItems: 'center', gap: 16, background: T.surface, border: `1px solid ${T.border}`, borderRadius: 16, padding: '18px 20px', cursor: 'pointer', textAlign: 'left', boxShadow: T.shadow, transition: 'box-shadow 0.15s, border-color 0.15s' }}
                  onMouseEnter={e => { e.currentTarget.style.boxShadow = T.shadowMd; e.currentTarget.style.borderColor = '#C8C0B4'; }}
                  onMouseLeave={e => { e.currentTarget.style.boxShadow = T.shadow; e.currentTarget.style.borderColor = T.border; }}>
                  <div style={{ width: 48, height: 48, borderRadius: 14, background: opt.grad, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', flexShrink: 0, boxShadow: '0 3px 8px rgba(0,0,0,0.15)' }}>{opt.icon}</div>
                  <div>
                    <p style={{ margin: 0, fontSize: 15, fontWeight: 600, color: T.text }}>{opt.label}</p>
                    <p style={{ margin: '3px 0 0', fontSize: 13, color: T.muted }}>{opt.sub}</p>
                  </div>
                </motion.button>
              ))}
            </div>
          </motion.div>
        )}

        {/* ── STEP 2: Compose ── */}
        {mode === 'compose' && (
          <motion.div key="compose" initial={{ opacity: 0, x: 30 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -30 }}
            style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>

            {/* Top bar */}
            <div style={{ position: 'sticky', top: 0, zIndex: 50, display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '14px 16px', background: 'rgba(247,245,240,0.95)', backdropFilter: 'blur(12px)', borderBottom: `1px solid ${T.border}` }}>
              <button onClick={() => setMode('pick')} style={{ background: 'none', border: 'none', color: T.muted, cursor: 'pointer', padding: 4 }}><Ic.Back /></button>
              <span style={{ fontSize: 15, fontWeight: 700, color: T.text }}>
                {contentType === 'text' ? 'Pravachan Notes' : contentType === 'image' ? 'New Post' : 'Audio Pravachan'}
              </span>
              <button onClick={handleSubmit} disabled={!canPost}
                style={{
                  background: canPost ? T.accent : T.border,
                  color: canPost ? '#fff' : T.muted,
                  border: 'none', borderRadius: 20, padding: '7px 18px',
                  fontSize: 14, fontWeight: 700,
                  cursor: canPost ? 'pointer' : 'not-allowed',
                  transition: 'all 0.15s',
                  boxShadow: canPost ? '0 2px 8px rgba(194,97,10,0.3)' : 'none',
                }}>
                {submitting ? '…' : anyUploading ? 'Uploading…' : postPublicly ? 'Post' : 'Save'}
              </button>
            </div>

            {/* Uploading banner — shown inline too when uploading */}
            <AnimatePresence>
              {anyUploading && (
                <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: 'auto', opacity: 1 }} exit={{ height: 0, opacity: 0 }}
                  style={{ background: '#FEF3C7', borderBottom: `1px solid #FDE68A`, overflow: 'hidden' }}>
                  <p style={{ margin: 0, padding: '8px 16px', fontSize: 12, color: '#92400E', fontWeight: 600, textAlign: 'center' }}>
                    ⏫ Upload in progress — don't close the app
                  </p>
                </motion.div>
              )}
            </AnimatePresence>

            {/* Meta fields */}
            <div style={{ padding: '16px 16px 0' }}>
              <div style={{ background: T.surface, borderRadius: 14, padding: '4px 0', border: `1px solid ${T.border}`, marginBottom: 12, boxShadow: T.shadow }}>
                <div style={{ display: 'flex', alignItems: 'center', padding: '11px 14px', borderBottom: `1px solid ${T.border}` }}>
                  <span style={{ fontSize: 12, fontWeight: 600, color: T.muted, width: 60, flexShrink: 0 }}>Speaker</span>
                  <input style={inputStyle} placeholder="Vakta name…" value={vakta} onChange={e => setVakta(e.target.value)} />
                </div>
                <div style={{ display: 'flex', alignItems: 'center', padding: '11px 14px', borderBottom: `1px solid ${T.border}` }}>
                  <span style={{ fontSize: 12, fontWeight: 600, color: T.muted, width: 60, flexShrink: 0 }}>Topic</span>
                  <input style={inputStyle} placeholder="Pravachan topic…" value={topic} onChange={e => setTopic(e.target.value)} />
                </div>
                <div style={{ display: 'flex', alignItems: 'center', padding: '11px 14px' }}>
                  <span style={{ fontSize: 12, fontWeight: 600, color: T.muted, width: 60, flexShrink: 0 }}>Date</span>
                  <input type="datetime-local" style={{ ...inputStyle, colorScheme: 'light' }} value={dateTime} onChange={e => setDateTime(e.target.value)} />
                </div>
              </div>
            </div>

            {/* ── Image content ── */}
            {contentType === 'image' && (
              <div style={{ padding: '0 16px' }}>
                {images.length > 0
                  ? <ImageCarousel images={images} onRemove={removeImage} />
                  : (
                    <div style={{ aspectRatio: '1', background: T.surface, border: `2px dashed ${T.border}`, borderRadius: 16, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 12, cursor: 'pointer' }} onClick={() => imgInputRef.current?.click()}>
                      <div style={{ fontSize: 40 }}>🖼️</div>
                      <p style={{ color: T.muted, fontSize: 14, margin: 0 }}>Tap to add photos</p>
                    </div>
                  )
                }
                {images.length > 0 && (
                  <div style={{ display: 'flex', gap: 8, padding: '10px 0', overflowX: 'auto' }}>
                    {images.map(img => (
                      <div key={img.name} style={{ width: 56, height: 56, borderRadius: 10, overflow: 'hidden', flexShrink: 0, border: `2px solid ${T.accent}` }}>
                        <img src={img.preview} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                      </div>
                    ))}
                    <button onClick={() => imgInputRef.current?.click()} style={{ width: 56, height: 56, borderRadius: 10, background: T.surface, border: `2px dashed ${T.border}`, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, color: T.muted }}><Ic.Add /></button>
                  </div>
                )}
                <input ref={imgInputRef} type="file" accept="image/*" multiple onChange={handleImageSelect} style={{ display: 'none' }} />
              </div>
            )}

            {/* ── Audio content ── */}
            {contentType === 'audio' && (
              <div style={{ padding: '0 16px' }}>
                <div style={{ background: T.surface, borderRadius: 16, padding: 24, border: `1px solid ${T.border}`, marginBottom: 12, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16, boxShadow: T.shadow }}>
                  <RecordingVisualiser active={recording} />
                  {recording && <p style={{ color: T.red, fontSize: 16, fontWeight: 700, fontVariantNumeric: 'tabular-nums', margin: 0 }}>● {fmt(recTime)}</p>}
                  {localAudioURL && !recording && <div style={{ width: '100%' }}><AudioPlayer src={localAudioURL} /></div>}
                  <div style={{ display: 'flex', gap: 12 }}>
                    {!recording
                      ? <button onClick={startRecording} style={{ display: 'flex', alignItems: 'center', gap: 8, background: T.red, color: '#fff', border: 'none', borderRadius: 24, padding: '11px 22px', fontSize: 14, fontWeight: 600, cursor: 'pointer', boxShadow: '0 2px 8px rgba(220,38,38,0.3)' }}><Ic.Mic /> Record</button>
                      : <button onClick={stopRecording} style={{ display: 'flex', alignItems: 'center', gap: 8, background: T.surface2, color: T.text, border: `1px solid ${T.border}`, borderRadius: 24, padding: '11px 22px', fontSize: 14, fontWeight: 600, cursor: 'pointer' }}>■ Stop</button>
                    }
                    {localAudioURL && !recording && (
                      <button onClick={saveLocalRecording} disabled={anyUploading}
                        style={{ display: 'flex', alignItems: 'center', gap: 8, background: T.green, color: '#fff', border: 'none', borderRadius: 24, padding: '11px 18px', fontSize: 14, fontWeight: 600, cursor: anyUploading ? 'not-allowed' : 'pointer', opacity: anyUploading ? 0.6 : 1, boxShadow: '0 2px 8px rgba(21,128,61,0.3)' }}>
                        <Ic.Check /> Save clip
                      </button>
                    )}
                  </div>
                </div>

                {/* Upload from file button */}
                <button onClick={() => audInputRef.current?.click()} disabled={anyUploading}
                  style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, padding: '13px 0', color: anyUploading ? T.muted : T.text, fontSize: 14, cursor: anyUploading ? 'not-allowed' : 'pointer', marginBottom: 12, boxShadow: T.shadow, opacity: anyUploading ? 0.6 : 1, transition: 'opacity 0.2s' }}>
                  <Ic.Upload /> {anyUploading ? 'Upload in progress…' : 'Upload audio file'}
                </button>
                <input ref={audInputRef} type="file" accept="audio/*,.mp3,.wav,.m4a,.aac" multiple onChange={handleAudioSelect} style={{ display: 'none' }} />

                {audioFiles.length > 0 && (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                    {audioFiles.map(af => <AudioPlayer key={af.name} src={af.url} />)}
                  </div>
                )}
              </div>
            )}

            {/* ── Caption / Notes ── */}
            <div style={{ padding: '12px 16px', flex: 1 }}>
              {contentType === 'text' ? (
                <div style={{ background: T.surface, borderRadius: 14, border: `1px solid ${T.border}`, overflow: 'hidden', boxShadow: T.shadow }}>
                  <div style={{ display: 'flex', gap: 4, padding: '8px 12px', borderBottom: `1px solid ${T.border}`, background: T.surface2 }}>
                    {[
                      { cmd: 'bold',      icon: <Ic.Bold /> },
                      { cmd: 'italic',    icon: <Ic.Italic /> },
                      { cmd: 'underline', icon: <span style={{ fontSize: 12, textDecoration: 'underline', fontWeight: 600 }}>U</span> },
                    ].map(b => (
                      <button key={b.cmd} onMouseDown={e => { e.preventDefault(); document.execCommand(b.cmd); editorRef.current?.focus(); }}
                        style={{ width: 28, height: 28, border: `1px solid ${T.border}`, borderRadius: 6, background: T.surface, color: T.text, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{b.icon}</button>
                    ))}
                    {[T.text, T.accent, '#1D9E75', T.red, '#2563EB'].map(c => (
                      <button key={c} onMouseDown={e => { e.preventDefault(); document.execCommand('styleWithCSS', false, 'true'); document.execCommand('foreColor', false, c); editorRef.current?.focus(); }}
                        style={{ width: 18, height: 18, borderRadius: '50%', background: c, border: `2px solid ${T.border}`, cursor: 'pointer' }} />
                    ))}
                  </div>
                  <div ref={editorRef} contentEditable suppressContentEditableWarning data-placeholder="Start writing your pravachan notes…"
                    style={{ minHeight: 200, padding: '14px 16px', color: T.text, fontSize: 15, lineHeight: 1.65, outline: 'none' }}
                    onPaste={e => { e.preventDefault(); document.execCommand('insertText', false, e.clipboardData.getData('text/plain')); }} />
                </div>
              ) : (
                <div style={{ background: T.surface, borderRadius: 14, border: `1px solid ${T.border}`, overflow: 'hidden', boxShadow: T.shadow }}>
                  <textarea value={caption} onChange={e => setCaption(e.target.value)} placeholder="Write a caption…" rows={4}
                    style={{ width: '100%', boxSizing: 'border-box', background: 'transparent', border: 'none', outline: 'none', color: T.text, fontFamily: 'inherit', fontSize: 15, lineHeight: 1.65, padding: '14px 16px', resize: 'none' }} />
                </div>
              )}
            </div>

            {/* ── PDF Attachments (available on all content types) ── */}
            <div style={{ padding: '0 16px 4px' }}>
              <p style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', color: T.muted, marginBottom: 8 }}>PDF Attachments</p>
              <button onClick={() => pdfInputRef.current?.click()} disabled={anyUploading}
                style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, background: T.surface, border: `1px dashed ${anyUploading ? T.border : '#FCA5A5'}`, borderRadius: 12, padding: '12px 0', color: anyUploading ? T.muted : '#DC2626', fontSize: 14, fontWeight: 600, cursor: anyUploading ? 'not-allowed' : 'pointer', opacity: anyUploading ? 0.6 : 1, transition: 'opacity 0.2s', boxShadow: T.shadow }}>
                <Ic.Pdf /> {anyUploading ? 'Upload in progress…' : 'Attach PDF'}
              </button>
              <input ref={pdfInputRef} type="file" accept="application/pdf,.pdf" multiple onChange={handlePdfSelect} style={{ display: 'none' }} />
              {pdfFiles.length > 0 && <PdfList pdfs={pdfFiles} onRemove={removePdf} />}
            </div>

            {/* ── Visibility toggle ── */}
            <div style={{ padding: '0 16px 24px' }}>
              <p style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', color: T.muted, marginBottom: 8 }}>Visibility</p>
              <div style={{ display: 'flex', gap: 8 }}>
                <button onClick={() => setPostPublicly(true)} style={{
                  flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6,
                  padding: '14px 10px',
                  background: postPublicly ? T.accentBg : T.surface,
                  border: `2px solid ${postPublicly ? T.accent : T.border}`,
                  borderRadius: 14, cursor: 'pointer', transition: 'all 0.2s',
                  boxShadow: postPublicly ? '0 2px 8px rgba(194,97,10,0.15)' : T.shadow,
                }}>
                  <div style={{ width: 36, height: 36, borderRadius: 10, background: postPublicly ? T.accent : T.surface2, display: 'flex', alignItems: 'center', justifyContent: 'center', color: postPublicly ? '#fff' : T.muted, transition: 'all 0.2s' }}><Ic.Globe /></div>
                  <span style={{ fontSize: 13, fontWeight: 700, color: postPublicly ? T.accent : T.muted }}>Public</span>
                  <span style={{ fontSize: 11, color: T.muted, textAlign: 'center' }}>Posted to community</span>
                </button>

                <button onClick={() => setPostPublicly(false)} style={{
                  flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6,
                  padding: '14px 10px',
                  background: !postPublicly ? '#F0F4FF' : T.surface,
                  border: `2px solid ${!postPublicly ? '#2563EB' : T.border}`,
                  borderRadius: 14, cursor: 'pointer', transition: 'all 0.2s',
                  boxShadow: !postPublicly ? '0 2px 8px rgba(37,99,235,0.1)' : T.shadow,
                }}>
                  <div style={{ width: 36, height: 36, borderRadius: 10, background: !postPublicly ? '#2563EB' : T.surface2, display: 'flex', alignItems: 'center', justifyContent: 'center', color: !postPublicly ? '#fff' : T.muted, transition: 'all 0.2s' }}><Ic.Lock /></div>
                  <span style={{ fontSize: 13, fontWeight: 700, color: !postPublicly ? '#2563EB' : T.muted }}>Private</span>
                  <span style={{ fontSize: 11, color: T.muted, textAlign: 'center' }}>Only visible to you</span>
                </button>
              </div>

              {!postPublicly && (
                <motion.div initial={{ opacity: 0, y: -4 }} animate={{ opacity: 1, y: 0 }}
                  style={{ marginTop: 10, background: '#EFF6FF', border: '1px solid #BFDBFE', borderRadius: 10, padding: '8px 12px', display: 'flex', alignItems: 'center', gap: 8 }}>
                  <span style={{ fontSize: 13, color: '#1D4ED8' }}>💡 This post will only be saved to your library, not shared publicly.</span>
                </motion.div>
              )}
            </div>

          </motion.div>
        )}
      </AnimatePresence>

      <style>{`
        [contenteditable]:empty:before { content: attr(data-placeholder); color: ${T.muted}; pointer-events: none; }
        input::placeholder, textarea::placeholder { color: ${T.muted}; }
        input[type="datetime-local"]::-webkit-calendar-picker-indicator { opacity: 0.5; }
        * { box-sizing: border-box; }
        @media (max-width: 480px) {
          div[style*="maxWidth:480"] { max-width: 100% !important; }
        }
      `}</style>
    </div>
  );
}